import { action } from 'typesafe-actions';
import { KpiACTypes, IKpi } from './types';

export const loadRequest = (
  cd: number,
  inscricao: number[],
  dataInicial: string,
  card: string,
  agrupar: number
) =>
  action(KpiACTypes.LOAD_REQUEST, {
    cd,
    dataInicial,
    agrupar,
    card,
    inscricao,
  });

export const loadSuccess = (data: IKpi[]) => action(KpiACTypes.LOAD_SUCCESS, { data });

export const loadFailure = () => action(KpiACTypes.LOAD_FAILURE, {});
